import { action } from '@reatom/framework'

import { Result } from '@blade/std-lib'
import { Network } from '@root/entities/network'
import { dependenciesAtom } from '@root/features/shared/dependencies'
import { ApiError, apiRequest } from '@root/shared/api'

import { WalletTransfers } from '../model'

import type { Address } from '@root/entities/address/Address'

/** A page of movements; the tab shows them and does not scroll for more. */
const LIMIT = 100

export const fetchWalletTransfersRequestAction = action(
  async (
    ctx,
    {
      network,
      walletAddress,
    }: { network: Network.Network; walletAddress: Address },
  ) => {
    const { tradeApiClient } = ctx.get(dependenciesAtom)
    const result = await ctx.schedule(() =>
      apiRequest(ctx, tradeApiClient.services.servicesWalletTransfersList, [
        { network: Network.toDto(network), walletAddress, limit: LIMIT },
      ]),
    )

    return result.pipe(
      Result.map(WalletTransfers.fromDto),
      Result.mapError(ApiError.fallbackToUnknown),
    )
  },
  'fetchWalletTransfersRequestAction',
)
